import {
    SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL,
    SYSTEM_ALT_LOG_CONTACTS_REQUEST,
    SYSTEM_ALT_LOG_CONTACTS_RESULT
} from 'Redux/actionTypes';

export const systemAlertContacsOpenModal = (open, contact, filters) => ({
    type: SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL,
    payload: { open, contact, filters }
})

export const systemAlertContacsRequest = (data) => ({
    type: SYSTEM_ALT_LOG_CONTACTS_REQUEST,
    payload: { data }
})

export const systemAlertContacsResult = (result) => ({
    type: SYSTEM_ALT_LOG_CONTACTS_RESULT,
    payload: { result }
})